import { Outlet, createFileRoute } from "@tanstack/react-router";

import { ClusterTabs, type ClusterTab } from "@/components/console/cluster-tabs";

// Delivery & platform: the outbox with retry state, and platform settings.
const DELIVERY_TABS: ClusterTab[] = [
  { label: "Outbox", to: "/ops/delivery/outbox" },
  { label: "System settings", to: "/ops/delivery/settings" },
  { label: "Obligation catalogue", to: "/ops/delivery/catalogue" },
];

export const Route = createFileRoute("/(app)/ops/delivery")({
  component: () => (
    <div className="flex w-full flex-col gap-3">
      <ClusterTabs items={DELIVERY_TABS} />
      <Outlet />
    </div>
  ),
});
